var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-indicators"},[(_vm.status)?_c('span',[_c('i',{staticClass:"far fa-check-circle text-green"})]):_c('span',[_c('i',{staticClass:"far fa-times-circle text-red"})])])}
var staticRenderFns = []

export { render, staticRenderFns }